var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85156 6.57031C5.77344 6.19531 6.65625 6.00781 7.5 6.00781C8.34375 6.00781 9.21875 6.19531 10.125 6.57031C11.0469 6.92969 11.5078 7.40625 11.5078 8V9.00781H3.49219V8C3.49219 7.40625 3.94531 6.92969 4.85156 6.57031ZM3 3.99219H4.5V5H3V6.5H1.99219V5H0.492188V3.99219H1.99219V2.49219H3V3.99219ZM8.90625 4.41406C8.51562 4.80469 8.04688 5 7.5 5C6.95312 5 6.48438 4.80469 6.09375 4.41406C5.70312 4.02344 5.50781 3.55469 5.50781 3.00781C5.50781 2.46094 5.70312 1.99219 6.09375 1.60156C6.48438 1.19531 6.95312 0.992188 7.5 0.992188C8.04688 0.992188 8.51562 1.19531 8.90625 1.60156C9.29688 1.99219 9.49219 2.46094 9.49219 3.00781C9.49219 3.55469 9.29688 4.02344 8.90625 4.41406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserAdd);
export default __webpack_public_path__ + "static/media/ic_user_add.60e57e77d3649605e6d091a2f113737c.svg";
export { ForwardRef as ReactComponent };